import {Layout as AntLayout} from "antd";

export const Layout = AntLayout;
export default Layout;
